export const PUBLISH_STATUS = [
  { id: 'published', name: 'Pushed' },
  { id: 'scheduled', name: 'Scheduled' },
];

export const TITLES = [{ id: 'WiB', name: 'WiB' }];
